import { useEffect, useRef, useState } from 'react';
import '../src/assets/css/dashboard.scss';
import { baseURL } from './components/BaseUrl';
import companySmallLogo from './assets/images/Sidebar/company-small-logo.svg';
// import loader from '../src/assets/images/Dashboard/loader.svg'
import loader from '../src/assets/images/Dashboard/loader.gif'
import { SBSaveUpdateBtn } from './components/Buttons/Buttons';
import { useNavigate } from 'react-router-dom';

const CallbackPage = () => {
    const [message, setMessage] = useState("Loading please wait...");
    const [authFailed, setAuthFailed] = useState(false);

    const callSingleActiveSessionApi = async () => {
        try {
            const signInDetails = JSON.parse(sessionStorage.getItem("SignInDetails"));
            let CustomerID = null;

            if (signInDetails[0]?.SignInType === "SuperAdmin") {
                CustomerID = signInDetails[0]?.SuperAdminID;
            } else if (signInDetails[0]?.SignInType === "ClientAdmin") {
                CustomerID = signInDetails[0]?.CompanyID;
            } else if (signInDetails[0]?.SignInType === "User") {
                CustomerID = signInDetails[0]?.UserID;
            }

            const response = await fetch(`${baseURL}/accountservices/api/account/SingleActiveSession`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "X-Api-Key": "f238b70537400820398f84fa1e1d12344314914eb7803d96b2ad497efed288d5"
                },
                body: JSON.stringify({
                    SigninType: signInDetails[0]?.SignInType,
                    DeviceType: "Web",
                    SigninID: CustomerID
                })
            });

            const result = await response.json();

            if (result?.Msg) {
                sessionStorage.setItem("signInToken", JSON.stringify(result.Msg));
                console.log("✅ Token stored successfully");
            } else {
                console.warn("⚠️ Token response missing `Msg` field");
            }

        } catch (error) {
            console.error("🚨 Token fetch failed", error);
        }
    };

    const effectRan = useRef(false);
    useEffect(() => {
        if (effectRan.current) return; // Skip if effect already ran (in Strict Mode second call)
        effectRan.current = true;
        const urlParams = new URLSearchParams(window.location.search);
        const authorizationCode = urlParams.get("code");
        const stateParam = urlParams.get("state"); // Identify Microsoft vs Okta
        const codeVerifier = sessionStorage.getItem("code_verifier"); // Only exists for Okta

        if (authorizationCode) {
            if (stateParam === "microsoft") {
                // ✅ Microsoft Authentication
                fetch(`${baseURL}/accountservices/api/account/AuthenticateWithMicrosoft`, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        "X-Api-Key": "f238b70537400820398f84fa1e1d12344314914eb7803d96b2ad497efed288d5"
                    },
                    body: JSON.stringify({ AuthorizationCode: authorizationCode }),
                })
                    .then((res) => res.json())
                    .then(async (resp) => {
                        if (resp.Success) {
                            sessionStorage.setItem("SignInDetails", JSON.stringify(resp.SignInDetails));
                            sessionStorage.setItem("AssignedModules", JSON.stringify(resp.AssignedModules));
                            sessionStorage.setItem("Success", "1");
                            setAuthFailed(false);
                            await callSingleActiveSessionApi();
                            window.location.href = "/";
                        } else {
                            setMessage("Microsoft Authentication Failed: " + resp.Message);
                            setAuthFailed(true);
                            setTimeout(() => navigate("/"), 10000);
                        }
                    })
                    .catch((error) => {
                        setMessage("Microsoft Authentication Failed: " + error.Message);
                        setAuthFailed(true);
                        setTimeout(() => navigate("/"), 10000);
                    });
            } else if (codeVerifier) {
                // ✅ Okta Authentication (only triggered if `code_verifier` exists)
                fetch(`${baseURL}/accountservices/api/account/AuthenticateWithOkta`, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        "X-Api-Key": "f238b70537400820398f84fa1e1d12344314914eb7803d96b2ad497efed288d5"
                    },
                    body: JSON.stringify({ AuthorizationCode: authorizationCode, CodeVerifier: codeVerifier }),
                })
                    .then((res) => res.json())
                    .then(async (resp) => {
                        if (resp.Success) {
                            sessionStorage.setItem("SignInDetails", JSON.stringify(resp.SignInDetails));
                            sessionStorage.setItem("AssignedModules", JSON.stringify(resp.AssignedModules));
                            sessionStorage.setItem("Success", "1");
                            setAuthFailed(false);
                            await callSingleActiveSessionApi();
                            window.location.href = "/";
                        } else {
                            setMessage("Okta Authentication Failed: " + resp.Message);
                            setAuthFailed(true);
                            setTimeout(() => navigate("/"), 10000);
                        }
                    })
                    .catch((error) => {
                        setMessage("Okta Authentication Failed: " + error.Message);
                        setAuthFailed(true);
                        setTimeout(() => navigate("/"), 10000);
                    });
            } else {
                setMessage("Unknown Authentication Attempt.");
                setAuthFailed(true);
                setTimeout(() => navigate("/"), 10000);
            }
        }
    }, []);

    const navigate = useNavigate();
    const handleFail = () => {
        navigate('/')
    }
    return (
        <div className='call-back-container'>
            <div className='call-back-image-div'>
                <img
                    src={companySmallLogo}
                    alt="Company Logo"
                    className='company-small-logo'
                />
            </div>
            <div className="call-back-card">
                <div className='call-back-loader-div'>
                    {!authFailed && <img src={loader} />}
                    {/* <h6> Loading please wait...</h6> */}
                    <h6>{message}</h6>
                    {authFailed && <SBSaveUpdateBtn onClickEffect={handleFail} btnName="Back to Login" />}
                </div>
            </div>
        </div>
    );
};

export default CallbackPage;
